export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "services",
      layout: "dashboard",
    },
    path: "/services",
    name: "services",
    component: () => import("@/layouts/index/ServiceIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste d'articles",
          layout: "dashboard",
        },
        path: "index",
        name: "services-index",
        component: () => import("@/views/services/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Creer un produit",
          layout: "dashboard",
        },
        path: "create",
        name: "services-create",
        component: () => import("@/views/services/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un produit",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "services-edit",
        component: () => import("@/views/services/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Prix ​​d'articles",
          layout: "dashboard",
        },
        path: "prices/index",
        name: "services-prices-index",
        component: () => import("@/views/item_prices/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Attribuer les prix de cet élément",
          layout: "dashboard",
        },
        path: "prices/create",
        name: "services-prices-create",
        component: () => import("@/views/item_prices/Create.vue"),
      },
    ],
  },
];
